import { ApolloError } from "@apollo/client";

const DEFAULT_MESSAGE = "Something went wrong, please try again";

/**
 * Extracts a user-facing message from an error thrown by an Apollo query or mutation, preferring
 * the messages returned by the API over Apollo's generic wrapper text.
 */
export const getGraphQLErrorMessage = (error: unknown, fallback = DEFAULT_MESSAGE): string => {
  if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
    return error.graphQLErrors.map((graphQLError) => graphQLError.message).join(" ");
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};
